<template>
  <div class="space-y-4">
    <AssetTile without-actions :asset="asset" />

    <div class="text-center">
      <BaseButton primary small :disabled="pending" @click="addAsset">
        <Loader v-if="pending" small inverse />
        <template v-else> Add </template>
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { orderItemLinksClient, orderItemNotesClient } from '@/api/clients';
import AssetTile from '@/components/Assets/AssetTile.vue';

export default {
  name: 'ConvertableAsset',
  components: {
    AssetTile,
  },
  props: {
    orderItemId: {
      type: String,
      required: true,
    },
    asset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pending: false,
    };
  },
  computed: {
    isLink() {
      return this.asset.assetableType === 'links';
    },
    isNote() {
      return this.asset.assetableType === 'notes';
    },
    isMedia() {
      return this.asset.assetableType === 'media';
    },
    assetable() {
      if (this.isLink) {
        return this.$store.state.entities.links.byId[this.asset.assetableId];
      }

      if (this.isNote) {
        return this.$store.state.entities.notes.byId[this.asset.assetableId];
      }

      if (this.isMedia) {
        return this.$store.state.entities.media.byId[this.asset.assetableId];
      }

      return null;
    },
  },
  methods: {
    async addAsset() {
      if (this.pending) {
        return;
      }

      try {
        this.pending = true;

        if (this.isLink || this.isMedia) {
          await this.tryCreateLink({
            description: this.assetable?.description || null,
            title: this.assetable?.title || null,
            url: this.assetable.url,
          });
        }

        if (this.isNote) {
          await this.tryCreateNote({
            content: this.assetable.content,
          });
        }
      } catch (error) {
        //
      } finally {
        this.pending = false;
      }
    },
    async tryCreateLink(formData) {
      try {
        const {
          data: { data },
        } = await orderItemLinksClient.store(this.orderItemId, formData);

        const orderItemId = await this.$store.dispatch('entities/persistEntities', {
          type: 'orderItems',
          data,
        });

        this.$emit('created', orderItemId);

        return Promise.resolve(orderItemId);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async tryCreateNote(formData) {
      try {
        const {
          data: { data },
        } = await orderItemNotesClient.store(this.orderItemId, formData);

        const orderItemId = await this.$store.dispatch('entities/persistEntities', {
          type: 'orderItems',
          data,
        });

        this.$emit('created', orderItemId);

        return Promise.resolve(orderItemId);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
